import axios from './AxiosService';

export default class FormaLlegadaService {

  async get_all() {
    return await axios.get('/forma-llegada').then(response => response.data);
  }

}